<h2>
	{{ "access.title" | translate }}
</h2>
<mat-card class="sdp-access-card">
	<ol>
		<li>
			<div class="sdp-access-section-container">
				<h4>{{ "access.section.1.header" | translate }}</h4>
				<div class="sdp-access-section-body">
					{{ "access.section.1.body" | translate }}
					<div class="sdp-access-section-right-side">
						<button
							mat-raised-button
							color="accent"
							(click)="openDemoSite()"
						>
							<sdp-icon [icon]="linkIcon"></sdp-icon>
							{{ "access.section.1.url.text" | translate }}
						</button>
					</div>
				</div>
			</div>
		</li>
		<li>
			<div class="sdp-access-section-container">
				<h4>{{ "access.section.2.header" | translate }}</h4>
				<div class="sdp-access-section-body">
					{{ "access.section.2.body" | translate }}
					<div class="sdp-access-section-right-side">
						<button
							mat-raised-button
							color="accent"
							(click)="openDownloadSite()"
						>
							<sdp-icon [icon]="downloadIcon"></sdp-icon>
							{{ "access.section.2.download.text" | translate }}
						</button>
					</div>
				</div>
			</div>
		</li>
		<li>
			<div class="sdp-access-section-container">
				<h4>{{ "access.section.3.header" | translate }}</h4>
				<div class="sdp-access-section-body sdp-access-section-body-multi-button">
					{{ "access.section.3.body" | translate }}
					<div class="sdp-access-section-right-side">
						<button
							mat-raised-button
							color="accent"
							(click)="loadEmailUrl()"
						>
							<sdp-icon [icon]="emailIcon"></sdp-icon>
							{{ "access.section.3.invite.text" | translate }}
						</button>
						<div class="sdp-access-button-seperator"></div>
						<button
							mat-raised-button
							color="accent"
							ngxClipboard
							[cbContent]="emailBody"
							(cbOnSuccess)="copied()"
						>
							<sdp-icon [icon]="copyIcon"></sdp-icon>
							{{ "access.section.3.copy.text" | translate }}
						</button>
					</div>
				</div>
			</div>
		</li>
	</ol>
</mat-card>